import getContent, { init } from 'pp-react-l10n';
import Page from './page';

const createl10n = (messages) => {
  init({
    content: messages,
  });

  return {
    getContent(...args) {
      return getContent(...args);
    },
  };
};

const l10n = createl10n(Page.getLocaleJson());

export default l10n;
